import { ItemTypes } from 'config';
import { useDrag } from 'react-dnd';
import useStyles from './CustomNodes/styles';
import useMenuStyles from './styles';

const AddMenu = () => {
  const { classes } = useStyles({});
  const { classes: menuClasses } = useMenuStyles();

  const [, drag1] = useDrag(() => ({
    type: ItemTypes.ROUTINE,
    item: { type: 'Routine' },
  }));

  const [, drag2] = useDrag(() => ({
    type: ItemTypes.ROUTINE,
    item: { type: 'CombinationalLogic' },
  }));

  const [, drag3] = useDrag(() => ({
    type: ItemTypes.ROUTINE,
    item: { type: 'FiniteStateMachine' },
  }));

  const [, drag4] = useDrag(() => ({
    type: ItemTypes.ROUTINE,
    item: { type: 'RelativeSchedule' },
  }));

  return (
    <div className={menuClasses.addMenu}>
      <h5>Drag routine to add it</h5>
      <div
        ref={drag1}
        className={classes.routine}
        style={{ width: 100, height: 50, cursor: 'move' }}
      >
        <h5>Leaf Routine</h5>
      </div>
      <div
        ref={drag2}
        className={classes.combinationalLogic}
        style={{ width: 100, height: 50, cursor: 'move' }}
      >
        <h5>Combinational Logic</h5>
      </div>
      <div
        ref={drag3}
        className={classes.finiteStateMachine}
        style={{ width: 100, height: 50, cursor: 'move' }}
      >
        <h5>Finite State Machine</h5>
      </div>
      <div
        ref={drag4}
        className={classes.schedule}
        style={{ width: 100, height: 50, marginBottom: 5, cursor: 'move' }}
      >
        <h5>Scheduler</h5>
      </div>
    </div>
  );
};

export default AddMenu;
